import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { useFieldArray, useForm } from "react-hook-form";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import APIS from "../../constant/EndPoint";
import { getApiData, postApiData } from "../../helpers/AxiosInstance";
import Button from "../Reusable/Button";
import Card from "../Reusable/Card";
import Modal from "../Reusable/Modal";
import ConsignmentForm from "./ConsignmentForm";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { createConsignmentValidationForm } from "../../utils/validationSchemas";

const CreateConsignment = (props: any) => {
  const {
    handleCreate,
    isLoading,
    defaultBranch,
    openAddReceiverPopup,
    setOpenAddReceiverPopup,
    openAddSenderPopup,
    setOpenAddSenderPopup,
    openPrintPopup,
    setOpenPrintPopup,
    profile,
    handleLabelPrintDownload,
    handleOrderReceiptDownload,
    isPrintLoading,
  } = props;
  const {
    control,
    register,
    handleSubmit,
    getValues,
    reset,
    watch,
    setFocus,
    setError,
    setValue,
    clearErrors,
    formState: { errors },
  } = useForm<any>({
    defaultValues: async () => {
      return {
        vendor: null,
        receiver_full_name: null,
        sender_full_name: null,
        sender_address: null,
        receiver_address: null,
        sender_phone_number: null,
        receiver_phone_number: null,
        sender_vat_pan: null,
        receiver_vat_pan: null,
        pickup_branch: defaultBranch,
        destination: null,
        hawb_no: null,
        cod: 0,
        ship_via: null,
        order_value: 0,
        service_type: null,
        payment_method: null,
        reference_date: moment().format("YYYY-MM-DD"),
        reference_type: null,
        reference_number: null,
        note: "",
        delivery_charge: 0,
        total_charge: null,
        extra_charges: {
          st: 25,
          // pickup: 0,
          // other: 0,
          // labour: 0,
          // freight: 0,
        },
        order_items: [
          {
            package_type: null,
            calculated_by: null,
            remark: null,
            weight: 0,
            piece: 1,
            rate: 0,
          },
        ],
      };
    },
    resolver: yupResolver(createConsignmentValidationForm),
  });

  const [openExtraChargePopup, setOpenExtraChargePopup] = useState(false);
  const [senderId, setSenderId] = useState<any>(null);
  const [receiverId, setReceiverId] = useState<any>(null);
  const { fields, append, remove } = useFieldArray({
    control,
    name: "order_items",
  });

  const handleClosePrintPopup = async () => {
    setOpenPrintPopup(false);

    const selectedVendor = getValues("vendor");

    if (!selectedVendor) {
      reset({
        vendor: null,
        receiver_full_name: null,
        sender_full_name: null,
        receiver_address: null,
        sender_address: null,
        receiver_phone_number: null,
        sender_phone_number: null,
        sender_vat_pan: null,
        ship_via: null,
        receiver_vat_pan: null,
        pickup_branch: defaultBranch,
        destination: null,
        hawb_no: null,
        cod: 0,
        order_value: 0,
        service_type: null,
        payment_method: null,
        reference_date: moment().format("YYYY-MM-DD"),
        reference_type: null,
        reference_number: null,
        delivery_charge: 0,
        total_charge: null,
        extra_charges: { st: 25 },
        order_items: [
          {
            package_type: null,
            calculated_by: null,
            remark: null,
            weight: 0,
            piece: 1,
            rate: 0,
          },
        ],
        note: "",
      });

      return;
    }

    reset({
      vendor: getValues("vendor"),
      receiver_full_name: getValues("receiver_full_name"),
      sender_full_name: getValues("sender_full_name"),
      receiver_address: getValues("receiver_address"),
      sender_address: getValues("sender_address"),
      receiver_phone_number: getValues("receiver_phone_number"),
      sender_phone_number: getValues("sender_phone_number"),
      sender_vat_pan: getValues("sender_vat_pan"),
      receiver_vat_pan: getValues("receiver_vat_pan"),
      pickup_branch: defaultBranch,
      destination: null,
      cod: 0,
      order_value: 0,
      service_type: getValues("service_type"),
      payment_method: getValues("payment_method"),
      reference_date: moment().format("YYYY-MM-DD"),
      reference_type: null,
      reference_number: null,
      delivery_charge: 0,
      ship_via: null,
      total_charge: null,
      hawb_no: null,
      extra_charges: { st: 25 },
      order_items: [
        {
          package_type: null,
          calculated_by: null,
          remark: null,
          weight: 0,
          piece: 1,
          rate: 0,
        },
      ],
      note: "",
    });
  };

  const vendor = watch("vendor");
  const pickup = watch("pickup_branch");
  const destination = watch("destination");
  const OrderItems = watch("order_items");
  const FreightCharge = watch("delivery_charge");
  // const PickupCharge = watch("extra_charges.pickup");
  // const LabourCharge = watch("extra_charges.labour");
  // const DeliveryCharge = watch("extra_charges.freight");
  const StCharge = watch("extra_charges.st");
  // const OtherCharge = watch("extra_charges.other");

  const handleSetCustomerDefaultValue = async (
    merchantId: string,
    pickup_branch: string,
    destination: string
  ) => {
    if (!merchantId || !pickup_branch || !destination) {
      return;
    }
    const url = `${APIS.ORDER}location-wise-customer/`;
    const formData = {
      vendor: merchantId,
      pickup_branch: pickup_branch,
      destination: destination,
    };
    const res = await postApiData({ url, formData, setError });
    if (res.status === 200) {
      setValue("sender_full_name", res?.data?.sender_name);
      setValue("receiver_full_name", res?.data?.receiver_name);
      setValue("sender_address", res?.data?.sender_address);
      setValue("receiver_address", res?.data?.receiver_address);
      setValue("sender_phone_number", res?.data?.sender_primary_contact);
      setValue("receiver_phone_number", res?.data?.receiver_primary_contact);
      setValue("sender_vat_pan", res?.data?.sender_vat_pan);
      setValue("receiver_vat_pan", res?.data?.receiver_vat_pan);
      setValue("vendor", merchantId);
    }
  };

  const vendorRef = useRef(null);
  useEffect(() => {
    if (vendorRef?.current) {
      vendorRef.current.focus();
    }
  }, [vendorRef]);

  const handleSenderAutoFillValue = async (senderId: any) => {
    const url = `${APIS.CUSTOMER}${senderId}/`;
    const res = await getApiData(url, {});
    if (res.status === 200) {
      setValue("sender_address", res?.data?.address);
      setValue("sender_phone_number", res?.data?.primary_contact);
      setValue("sender_vat_pan", res?.data?.vat_pan);
    }
  };
  const handleReceiverAutoFillValue = async (receiverId: any) => {
    const url = `${APIS.CUSTOMER}${receiverId}/`;
    const res = await getApiData(url, {});
    if (res.status === 200) {
      setValue("receiver_address", res?.data?.address);
      setValue("receiver_phone_number", res?.data?.primary_contact);
      setValue("receiver_vat_pan", res?.data?.vat_pan);
    }
  };
  const handlesetDefaultValue = async (merchantId: string) => {
    if (!vendor) {
      setValue("service_type", null);
      setValue("payment_method", null);
      setValue("extra_charges.st", 25);
      return;
    }
    const url = `${APIS.MERCHANT}${merchantId}/`;
    const res = await getApiData(url, {});
    if (res.status === 200) {
      setValue("service_type", res?.data?.default_service_type);
      setValue("payment_method", res?.data?.default_payment_method);
      setValue("extra_charges.st", res?.data?.st_charge);
    }
  };

  useEffect(() => {
    handlesetDefaultValue(vendor);
    setValue("sender_full_name", null);
    setValue("receiver_full_name", null);
    handleSetCustomerDefaultValue(vendor, pickup, destination);
  }, [vendor, pickup, destination, setValue]);

  useEffect(() => {
    if (!senderId) return;
    handleSenderAutoFillValue(senderId);
  }, [senderId]);

  useEffect(() => {
    if (!receiverId) return;
    handleReceiverAutoFillValue(receiverId);
  }, [receiverId]);

  const calculateTotalDeliveryCharge = (items) => {
    if (!items) return;

    return items.reduce((total, item) => {
      const weight = Number(item?.weight) || 0;
      const piece = Number(item?.piece) || 0;
      const rate = Number(item?.rate) || 0;
      if (item?.calculated_by?.id === "weight") {
        return total + weight * rate;
      } else {
        return total + piece * rate;
      }
    }, 0);
  };

  const totalDeliveryCharge = calculateTotalDeliveryCharge(OrderItems);

  // useEffect(() => {
  //   setValue("delivery_charge", totalDeliveryCharge);
  // }, [totalDeliveryCharge]);
  useEffect(() => {
    const hasRate = OrderItems?.some((item) => Number(item?.rate) > 0);
    if (!hasRate) return;

    setValue("delivery_charge", totalDeliveryCharge);
  }, [totalDeliveryCharge]);

  useEffect(() => {
    const TotalCharge =
      // Number(PickupCharge) +
      // Number(DeliveryCharge) +
      // Number(LabourCharge) +
      Number(StCharge) + Number(FreightCharge);

    setValue("total_charge", TotalCharge);
  }, [
    // PickupCharge,
    // DeliveryCharge,
    // LabourCharge,
    StCharge,
    FreightCharge,
    // OtherCharge,
    setValue,
  ]);

  return (
    <>
      <Card>
        <form
          onSubmit={handleSubmit((data) => handleCreate(data, setError))}
          autoComplete="off"
        >
          <ConsignmentForm
            profile={profile}
            clearErrors={clearErrors}
            errors={errors}
            register={register}
            setValue={setValue}
            getValues={getValues}
            watch={watch}
            setFocus={setFocus}
            openAddReceiverPopup={openAddReceiverPopup}
            setOpenAddReceiverPopup={setOpenAddReceiverPopup}
            openAddSenderPopup={openAddSenderPopup}
            setOpenAddSenderPopup={setOpenAddSenderPopup}
            setOpenExtraChargePopup={setOpenExtraChargePopup}
            openExtraChargePopup={openExtraChargePopup}
            fields={fields}
            append={append}
            remove={remove}
            setSenderId={setSenderId}
            setReceiverId={setReceiverId}
            vendorRef={vendorRef}
            control={control}
          />
          <div className={tw`flex justify-end gap-4 mr-4`}>
            <div className={tw`w-32`}>
              <Button
                disabled={isLoading}
                isLoading={isLoading}
                onClick={() => {
                  vendorRef.current.focus();
                }}
                label={"Create & Print"}
              />
            </div>
          </div>
        </form>
      </Card>
      <Modal
        isOpen={openPrintPopup}
        setIsOpen={handleClosePrintPopup}
        title={"Print "}
      >
        <form action="#" className={tw`w-[600px]`}>
          <Button
            label={"Print Label"}
            type="button"
            isLoading={isPrintLoading}
            disabled={isPrintLoading}
            onClick={handleLabelPrintDownload}
            autoFocus
          />
          <Button
            label={"Print Receipt"}
            isLoading={isPrintLoading}
            disabled={isPrintLoading}
            type="button"
            onClick={handleOrderReceiptDownload}
          />
          <Button
            type="button"
            label={"Close"}
            onClick={handleClosePrintPopup}
          />
        </form>
      </Modal>
    </>
  );
};

export default CreateConsignment;
